export { default as useClickOutside } from './use-click-outside';
